var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "content" } }, [
    _c("div", { staticClass: "header col-md-12" }, [
      _c("div", { staticClass: "header-inner row align-items-center" }, [
        _c("div", { staticClass: "col left" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(
              "\n          " +
                _vm._s(_vm.$t("sidebar.overviews")) +
                " > " +
                _vm._s(_vm.$t("sidebar.todoinventory")) +
                "\n        "
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "content col-md-12" }, [
      !_vm.ready
        ? _c("p", [_vm._v(_vm._s(_vm.$t("message.loading")))])
        : _vm._e(),
      _vm._v(" "),
      _vm.ready && _vm.todo.length > 0
        ? _c(
            "div",
            { staticClass: "col-md-12 no-padding no-margin row" },
            _vm._l(_vm.todo, function(item, index) {
              return _c("div", { staticClass: "col-md-12 col-lg-12" }, [
                _c(
                  "div",
                  { staticClass: "col-lg-6 card" },
                  [
                    _c("section-title", {
                      attrs: {
                        title: item.warehouse.warehouse_name,
                        fontweight: "bold"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-12 no-padding no-margin row" },
                      [
                        _c(
                          "div",
                          { staticClass: "col-md-4 mb-2 no-padding" },
                          [
                            _c("p", [
                              _vm._v(_vm._s(_vm.$t("message.receiptsorders")))
                            ]),
                            _vm._v(" "),
                            [
                              item.goodsreceipt.todo > 0
                                ? _c(
                                    "router-link",
                                    {
                                      staticClass: "btn btn-web btn-sm",
                                      attrs: {
                                        to: {
                                          name: "GoodsReceiptAll",
                                          query: {
                                            page: 1,
                                            wh: item.warehouse.warehouse_id,
                                            status: "padding"
                                          }
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(item.goodsreceipt.todo) +
                                          "\n                  " +
                                          _vm._s(_vm.$t("message.toprocess")) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                : _c("span", [_vm._v("-")])
                            ]
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-md-4 mb-2 no-padding" },
                          [
                            _c("p", [
                              _vm._v(_vm._s(_vm.$t("message.deliveryorders")))
                            ]),
                            _vm._v(" "),
                            [
                              item.goodsissue.todo
                                ? _c(
                                    "router-link",
                                    {
                                      staticClass: "btn btn-web btn-sm",
                                      attrs: {
                                        to: {
                                          name: "GoodsIssueAll",
                                          query: {
                                            page: 1,
                                            wh: item.warehouse.warehouse_id,
                                            status: "padding"
                                          }
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(item.goodsissue.todo) +
                                          "\n                  " +
                                          _vm._s(_vm.$t("message.toprocess")) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                : _c("span", [_vm._v("-")])
                            ]
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-md-4 mb-2 no-padding" },
                          [
                            _c("p", [
                              _vm._v(_vm._s(_vm.$t("message.transferorders")))
                            ]),
                            _vm._v(" "),
                            [
                              item.goodstransfer.todo
                                ? _c(
                                    "router-link",
                                    {
                                      staticClass: "btn btn-web btn-sm",
                                      attrs: {
                                        to: {
                                          name: "GoodsTransferAll",
                                          query: {
                                            page: 1,
                                            wh: item.warehouse.warehouse_id,
                                            status: "padding"
                                          }
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(item.goodstransfer.todo) +
                                          "\n                  " +
                                          _vm._s(_vm.$t("message.toprocess")) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                : _c("span", [_vm._v("-")])
                            ]
                          ],
                          2
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
            }),
            0
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d470ed88", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d470ed88","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/inventory/overview/Todo.vue
// module id = null
// module chunks = 